import { render, staticRenderFns } from "./BUserPicker.vue?vue&type=template&id=50a465bb&scoped=true&"
import script from "./BUserPicker.vue?vue&type=script&lang=js&"
export * from "./BUserPicker.vue?vue&type=script&lang=js&"
import style0 from "./BUserPicker.vue?vue&type=style&index=0&id=50a465bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a465bb",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QForm,QBtn});
